import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { VitaArchivio } from '../../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { useDeleteVitaArchivio, useUpdateVitaArchivio, useVitaArchivio } from '../../hooks/vite-archivio'
import VitaArchivioForm from '../../components/VitaArchivioForm'

export default function ViteArchivioEdit() {
  const { id } = useParams()
  const { data: vita, refetch } = useVitaArchivio(+id!)
  const deleteVita = useDeleteVitaArchivio()
  const updateVita = useUpdateVitaArchivio()
  const [modalRm, modalRmActions] = useModalTrigger<VitaArchivio>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/vite-archivio">Vite d'archivio</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {vita!.title.it}
            </li>
          </ol>
        </nav>
        <button
          className="btn  btn-danger"
          onClick={() => modalRmActions.open(vita)}
        >
          <i className="bi bi-trash3-fill"></i> Elimina
        </button>
      </Header>

      <div className="py-3 overflow-y-auto flex-1">
        <VitaArchivioForm
          refetch={refetch}
          vita={vita}
          save={(formVita) =>
            updateVita.mutateAsync(formVita).then(() =>
              toast.success('Vita d archivio salvata con successo!', {
                position: 'bottom-right',
                theme: 'colored',
              })
            )           
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare la vita d'archivio {modalRm.value.title.it} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btnoutline-primary"
          >
            Annulla
          </button>
          <button
            className="btn  btn-danger"
            disabled={deleteVita.isLoading}
            onClick={async () => {
              await deleteVita.mutateAsync(modalRm.value!.id)
              navigate('/vite-archivio')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
